import React, {useState} from 'react';
import  { Heading } from '../../../components/common/heading.module.js';
import {FAQPageData, WebSiteData} from '../../components/structuredData.js'

import {RtFAQFileItem} from '../../../../server/routes/route-types.js'
import {RtFAQPageResult} from '../../../../server/routes/main.js'

// Interface for FAQ page data
// interface FAQPageData {
//     faqs: RtFAQFileItem[];
// }

// Interface for component props
interface FAQProps {
    server: string;
    pageData: unknown;
}

export default function FAQ({server, pageData}: FAQProps) {

	let [data, setData] = useState(pageData as RtFAQPageResult);

    
    return (
        <>
        <FAQPageData faq={data.faqs} />
        <div  className={ "app" }>
			<section className="section section-lg reports-body">
				<div className="container">
                    <div className="row row-50">
                        <Heading
                            heading={"FAQ"}
                        />                       
                    </div>
                    <div className="row row-50">
                        <div className="col"> 
                            <div id="accordion">
                            {
                                data.faqs.map( (faq, index) =>
                                    <FAQElement 
                                        key={index}
                                        index={index}
                                        faq={faq} 
                                    />)
                            }
                            </div>
                        </div>
                    </div>
				</div>
			</section>

        </div>

        </>
	)
}

// Interface for FAQElement props
interface FAQElementProps {
    index: number;
    faq: RtFAQFileItem;
}

function FAQElement({index, faq}: FAQElementProps) {
/**
<div className="card-body faq-answer">
        {faq.answer}
    </div>   
 */

    return (<>
        <div className="card">
            <div className="card-header faq" id={`heading${index}`}>
            <h5 className="mb-0">
                <button 
                    className={`btn btn-link ${index != 0 ? 'collapsed' : ''}`} 
                    data-toggle="collapse" 
                    data-target={`#collapse${index}`} 
                    aria-expanded={index == 0 ? 'true' : 'false'}
                    aria-controls={`collapse${index}`}
                >
                    <b>{faq.question}</b>
                </button>
            </h5>
            </div>

            <div 
                id={`collapse${index}`} 
                className={`collapse ${index == 0 ? 'show' : ''}`} 
                aria-labelledby={`heading${index}`} 
                data-parent="#accordion"
            >
                <div className="card-body faq-answer" dangerouslySetInnerHTML={{__html: faq.answer}}/>         
            </div>
        </div>
    </>)
}
